<template>
  <el-dialog
    title="编辑角色"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" ref="roleForm" label-width="90px" size="small">
      <!-- 角色名称 -->
      <el-form-item label="角色名称" prop="role_name">
        <el-input v-model.trim="form.role_name" placeholder="请输入角色名称" />
      </el-form-item>

      <!-- 角色编号 -->
      <el-form-item label="角色编号" prop="role_code">
        <el-input v-model.trim="form.role_code" placeholder="请输入角色编号（可选）" />
      </el-form-item>

      <!-- 显示顺序 -->
      <el-form-item label="显示顺序" prop="display_order">
        <el-input-number
          v-model="form.display_order"
          :min="0"
          :max="999"
          placeholder="排序值越小越靠前"
          style="width: 100%;"
        />
      </el-form-item>

      <!-- 状态 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注信息" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.remark"
          placeholder="请输入备注信息（可选）"
        />
      </el-form-item>

      <!-- 菜单选择（树形多选） -->
      <el-form-item label="分配菜单" prop="menuIds">
        <el-tree
          ref="menuTree"
          :data="menuList"
          show-checkbox
          node-key="id"
          :props="treeProps"
          highlight-current
          default-expand-all
          :expand-on-click-node="false"
          empty-text="加载中..."
          @check="handleMenuCheck"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="data.path" style="color: #999; font-size: 12px; margin-left: 8px;">
              {{ data.path }}
            </span>
          </span>
        </el-tree>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditRole',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,

      // 当前编辑的角色 ID
      roleId: null,

      // 表单数据
      form: {
        role_name: null,
        role_code: null,
        display_order: 0,
        status: 0,
        remark: null,
        menuIds: [] // 选中的菜单 ID 数组
      },

      // 验证规则
      rules: {
        role_name: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        menuIds: [
          { 
            required: true, 
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请至少选择一个菜单权限'));
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
          }
        ]
      },

      // 菜单树数据
      menuList: [],
      menuLoading: false,

      // el-tree 配置
      treeProps: {
        label: 'name',
        children: 'children'
      }
    };
  },
  methods: {
    // 打开弹窗，传入角色数据
open(roleData) {
  if (!roleData || !roleData.id) {
    this.$message.error('无效的角色数据');
    return;
  }

  this.dialogVisible = true;
  this.roleId = roleData.id;

  // ✅ 清空上一次的菜单数据和选中状态
  this.menuList = [];
  this.form.menuIds = [];

  // ✅ 强制重新加载菜单（不再使用缓存）
  this.loadMenus().then(() => {
    this.$nextTick(() => {
      // 回填表单基本信息
      this.form = {
        role_name: roleData.role_name,
        role_code: roleData.role_code || null,
        display_order: roleData.display_order || 0,
        status: roleData.status != null ? roleData.status : 0,
        remark: roleData.remark || null,
        menuIds: []
      };

      // ✅ 从新的 menuList 中提取 checked: true 的节点
      const selectedMenuIds = [];
      const extractChecked = (items) => {
        items.forEach(item => {
          if (item.checked) {
            selectedMenuIds.push(item.id);
          }
          if (item.children && item.children.length > 0) {
            extractChecked(item.children);
          }
        });
      };
      extractChecked(this.menuList);

      // 同步到表单和 Tree
      this.form.menuIds = selectedMenuIds;
      this.$refs.menuTree.setCheckedKeys(selectedMenuIds);

      // 清除校验
      this.$refs.roleForm.clearValidate();
    });
  });
},
 //同步 tree 选中变化到 form.menuIds
  handleMenuCheck(data, checkedNodes) {
    const checkedKeys = checkedNodes.checkedKeys;
    this.$set(this.form, 'menuIds', checkedKeys);
  },

    // 重置表单
    resetForm() {
      if (this.$refs.roleForm) {
        this.$refs.roleForm.resetFields();
      }
      this.form.menuIds = [];
      this.$nextTick(() => {
        if (this.$refs.menuTree) {
          this.$refs.menuTree.setCheckedKeys([]);
        }
      });
    },

    // 加载菜单树
    // loadMenus() {
    //   return new Promise((resolve, reject) => {
    //     if (this.menuList.length > 0) {
    //       resolve();
    //       return;
    //     }

    //     this.menuLoading = true;
    //     this.$axios
    //       .get('/api-30216/api/roles/menus')
    //       .then(res => {
    //         const rawData = res.data;
    //         const data = rawData && rawData.data ? rawData.data : (Array.isArray(rawData) ? rawData : []);
    //         this.menuList = data;
    //         resolve();
    //       })
    //       .catch(err => {
    //         this.$message.error('加载菜单失败');
    //         console.error(err);
    //         reject(err);
    //       })
    //       .finally(() => {
    //         this.menuLoading = false;
    //       });
    //   });
    // },

    // 加载菜单树（带角色ID）
loadMenus() {
  return new Promise((resolve, reject) => {
    // ❌ 移除缓存判断：if (this.menuList.length > 0) ...

    this.menuLoading = true;
    this.$axios
      .get('/api-30216/api/roles/menus', {
        params: {
          roleId: this.roleId  // 必须传
        }
      })
      .then(res => {
        const rawData = res.data;
        const data = rawData && rawData.data ? rawData.data : (Array.isArray(rawData) ? rawData : []);
        this.menuList = data;
        resolve();
      })
      .catch(err => {
        this.$message.error('加载菜单失败');
        console.error(err);
        reject(err);
      })
      .finally(() => {
        this.menuLoading = false;
      });
  });
},

    // 提交编辑
    submitForm() {
  this.$refs.roleForm.validate(valid => {
    if (!valid) {
      this.$message.warning('请检查表单填写');
      return;
    }

    // ✅ 再次确认 menuIds
    if (!this.form.menuIds || this.form.menuIds.length === 0) {
      this.$message.error('请至少选择一个菜单权限');
      return;
    }

    const postData = { ...this.form };

    this.submitLoading = true;
    this.$axios
      .put(`/api-30216/api/roles/${this.roleId}`, postData, {
        headers: { 'Content-Type': 'application/json' },
        transformRequest: [postData => JSON.stringify(postData)]
      })
      .then(res => {
        const responseData = res.data || res;
        if (responseData.code === 200) {
          this.$message.success('角色更新成功');
          this.dialogVisible = false;
          this.$emit('success');
        } else {
          this.$message.error(responseData.message || '更新失败');
        }
      })
      .catch(err => {
        let msg = '更新角色失败';
        if (err.response && err.response.data && err.response.data.message) {
          msg = err.response.data.message;
        } else if (err.message) {
          msg = err.message;
        }
        this.$message.error(msg);
      })
      .finally(() => {
        this.submitLoading = false;
      });
  });
}
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>